import React from 'react';
import type { SolutionVisualId } from '../../types/platform';
import { MemoExcerpt } from './visuals/MemoExcerpt';
import { VendorComparison } from './visuals/VendorComparison';
import { WorkstreamTracker } from './visuals/WorkstreamTracker';
import { ApplicationScorecard } from './visuals/ApplicationScorecard';
import { RiskRegister } from './visuals/RiskRegister';
import { MilestoneTimeline } from './visuals/MilestoneTimeline';
const VISUALS: Record<SolutionVisualId, React.ComponentType> = {
  memo: MemoExcerpt,
  vendor: VendorComparison,
  workstreams: WorkstreamTracker,
  scorecard: ApplicationScorecard,
  risk: RiskRegister,
  timeline: MilestoneTimeline
};
export function SolutionVisual({
  id
}: {
  id: SolutionVisualId;
}) {
  const Visual = VISUALS[id];
  return <Visual data-id="element-1369" data-mp="347co21khcv77" />;
}